<template>
  <div>

    <b-card>
      <b-row>
        <b-col class="d-flex justify-content-end">

          <b-button 
            class="btn btn-success" 
            @click="onShowModalCreate()"
          >
            Crear
          </b-button>

          <b-button
            class="ml-1"
            variant="success"
            size="sm"
            @click="descargarCartIma()"
            v-b-tooltip.hover
            title="Descargar cartera Imagenes"
          >
            <div v-if="descargandoExcel">
              <b-spinner small type="grow"></b-spinner>
              <label style="color: whitesmoke;">Descargando..</label> 
            </div>
            <i class="fas fa-file-excel"></i>
          </b-button>  
        </b-col>
      </b-row>

      <hr>

      <b-row class="my-2 mx-1">

        <h5 class="col-12">Busqueda:</h5>
        <b-form-input 
          v-model="filters.search" 
          placeholder="Buscar por nombre o código de la imagen." 
          type="text"
          :class="isXima ? 'col-3' : 'col-4'" 
        />

        <v-select 
          id="tipoImagen" 
          v-model="filters.tipoImagen" 
          :options="tipoImagenOpts"
          :reduce="option => option.value" 
          placeholder="Seleccionar tipo de imagen." 
          label="text" 
          :class="isXima ? 'col-3' : 'col-3'" 
        />

        <v-select
          v-if="isXima"
          id="establecimiento"
          v-model="filters.establecimiento"
          :options="establecimientosOpts"
          :reduce="option => option.value"
          placeholder="Seleccionar establecimiento."
          label="text"
          class="col-3"
        />

        <b-col class="ml-1 col-2">
          <b-button 
            variant="primary" 
            @click="buscarImagen"
          >
            <font-awesome-icon icon="magnifying-glass" style="color: white;" />
            Buscar
          </b-button>
        </b-col>

      </b-row>


      <!-- <div v-if="canModificar">
        <hr/>

        <b-row >
          <h5 class="col-12">Modificar informacion de cartera</h5>
          <v-select 
            v-model="modificar.estado" 
            placeholder="Estado." 
            :options="estados"
            :reduce="option => option.value" 
            label="text" 
            class="col-2" 
          />

          <v-select 
            id="tipoImagen" 
            v-model="modificar.tipoImagen" 
            :options="tipoImagenOpts"
            :reduce="option => option.value" 
            placeholder="Tipo de imagen." 
            label="text" 
            class="col-3 " 
          />

          <b-col md="4" class="col-2">
            <b-button 
              variant="primary" 
              @click="modificarItems"
            >
              <span style="color: white;">
                Cambiar
              </span>
            </b-button>

          </b-col>
        </b-row>
      </div> -->
      
    </b-card>


    <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
      <b-card class="principal">

        <div class="d-flex justify-content-between mb-1 mx-1">
          <div class="d-flex text-success align-items-center">
            <i class="fa-solid fa-filter"/>
            <span class="mx-1" v-html="getFiltrosAplicados"></span>
          </div>
          <h5>Resultados: {{ table.totalRows }}</h5>
        </div>

        <b-col cols="12" class="pr-0 pl-0 mt-2">

          <b-table 
            v-if="items.length > 0" 
            bordered striped responsive 
            :items="items"
            :fields="fieldsTable" 
            :sort-by.sync="sortBy" 
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection" 
          >
            <template #cell(check)="data">
              <b-form-checkbox @change="selectedImagen(data.item.idImagen)"/>
            </template>

            <template #cell(nombre)="data">
              <div v-b-tooltip.hover :title="data.item.nombreCompleto">
                {{ truncateNombre(data.item.nombreCompleto || '') }}
              </div>
            </template>

            <template #cell(estadoJson)="data">
              <div class="row">
                <label class="col-6" >Iess: <label :class="data.item.estadoJson.iess? 'text-success' : 'text-danger'"> {{ data.item.estadoJson.iess? 'Activo' : 'Inactivo' }} </label> </label> 
                <label class="col-6">Issfa: <label :class="data.item.estadoJson.issfa? 'text-success' : 'text-danger'"> {{ data.item.estadoJson.issfa? 'Activo' : 'Inactivo' }} </label> </label> 
              
                <label class="col-6" >Isspol: <label :class="data.item.estadoJson.isspol? 'text-success' : 'text-danger'"> {{ data.item.estadoJson.isspol? 'Activo' : 'Inactivo' }} </label> </label> 
                <label class="col-6">Particular: <label :class="data.item.estadoJson.particular? 'text-success' : 'text-danger'"> {{ data.item.estadoJson.particular? 'Activo' : 'Inactivo' }} </label> </label> 
              </div>
            </template>

            <template #cell(establecimientos)="data">
              <div class="d-flex flex-column text-left">
                <span
                  v-for="est in data.item.establecimientos"
                  :key="est.id"
                >
                  {{ est.nombre }}:
                  <span :class="est.activo ? 'text-success' : 'text-danger'">
                    {{ est.activo ? 'Activo' : 'Inactivo' }}
                  </span>
                </span>
              </div>
            </template>

            <template #cell(estado)="data">
              <label 
                v-if="data.item.estado === '1'"
                style="
                  background-color: #92DB92;
                  box-shadow: 0 0 10px rgba(4, 219, 0, 0.6);
                  border-radius: 3px;
                  padding: 3px;
                " 
              >
                Activo
              </label>

              <label 
                v-else
                style="
                  background-color: #DBD5CC;
                  border-radius: 3px;
                  padding: 3px;
                " 
              >
                Inactivo
              </label>
            </template>

            <template #cell(acciones)="data">
              <div class="d-flex justify-content-end">

                <b-button 
                  variant="info" 
                  size="sm" 
                  @click="viewItem(data.item.tokenImagen)"
                >
                  <font-awesome-icon icon="magnifying-glass" style="color: white;" />
                </b-button>
                
                <b-button 
                  variant="primary"
                  size="sm" 
                  @click="onShowModalEdit(data.item.tokenImagen)"
                >
                  <font-awesome-icon icon="user-pen" style="color: white;" />
                </b-button>

                <b-button 
                  variant="danger" 
                  size="sm" 
                  @click="removeItemid(data.item.idImagen)"
                >
                  <font-awesome-icon icon="circle-xmark" style="color: white;" />
                </b-button>
              </div>
            </template>
          </b-table>
          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-col cols="12" class="mb-2">
          <b-pagination 
            v-if="items.length > 0" 
            v-model="table.page" 
            :total-rows="table.totalRows"
            :per-page="table.pageSize" 
            :small="true" 
            first-number 
            class="mb-0" 
            align="center"
            prev-class="prev-item" 
            next-class="next-item" 
            @change="cambiarPagina"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>

            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>

      </b-card>
    </b-overlay>

    <ModalEditarImagen 
      :tokenImagen="tokenEditarImagen" 
      :isVisible.sync="showModalEdit" 
    />

    <b-modal v-model="modalShow" @show="cargarComponente" title="Detalles de la Imagen" size="md">
      <component 
        :is="componenteDinamico" 
        v-if="componenteDinamico" 
        :token="tokenSeleccionado"
      ></component>
    </b-modal>

    <ModalCrearImagen
      :isVisible.sync="showModalCreate" 
    />


    <SaveImagenCartera/>

  </div>

</template>

<script>
import axios            from 'axios';
import rutas            from '@/assets/utils/rutas.json';
import { BootstrapVue } from 'bootstrap-vue';
import actions          from '@/assets/utils/utils'
import vSelect          from 'vue-select'
import { comprobarPermisos, comprobarRoles, getEstablecimientoLS } from "@/shared/helpers";
import { establecimientosService } from '@/views/administracion/services';
import SaveImagenCartera from '@/views/imagen/components/SaveImagenCartera/SaveImagenCartera.vue';
import { fetchTipoImagenSelect } from '../services/tipoImagen';
import { ModalEditarImagen, ModalCrearImagen } from "../components";
import { carteraImagenService } from '../services';
import { ROLES } from '../../../shared/constants';


export default {

  name: 'CarteraImagen',

  components: {
    ...BootstrapVue.components,
    ModalEditarImagen,
    vSelect,
    ModalCrearImagen,

    SaveImagenCartera
  },

  data() {
    return {

      filters:{
        search: '',
        tipoImagen: '',
        establecimiento: null,
      },

      table:{
        page: 1,
        pageSize: 15,
        totalRows: 0
      },

      descargandoExcel : false,
      showModalCreate: false,
      showModalEdit: false,
      establecimientosOpts: [],
      tipoImagenOpts: [],
      tokenEditarImagen: null,

      tokenSeleccionado: null,
      modalShow: false,
      componenteDinamico: null,
      currentPage: 1,
      currentPageModificado: 1,
      mostrarLoader: false,
      login_user: '',
      consultarimagen: null,
      consultarestablecimiento: '',
      establecimiento: '',
      consultartipoImagen: '',
      tipoImagen: '',
      tiposImagen: [],
      perPage: 15,
      pageOptions: [3, 5, 10],
      totalRows: 3,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      currentEstablecimiento: getEstablecimientoLS && getEstablecimientoLS(),
      filterOn: [],
      tokenImagen: null,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fieldsTable: [
        // { key: 'check',           label: '', thClass: 'text-center' },
        { key: 'estadoJson',       label: 'Estado',            sortable: true,  thClass: 'text-center', thStyle: { width: '190px' } },
        { key: 'establecimientos', label: 'Establecimiento',   sortable: false, thClass: 'text-center' },
        { key: 'nombre',           label: 'Nombre',            sortable: true,  thClass: 'text-center', thStyle: { width: '260px' } },
        // { key: 'precio',     label: 'Precio',         sortable: true, thClass: 'text-center' },
        { key: 'tipoImagen',       label: 'Tipo de Imagen',    sortable: true,  thClass: 'text-center' },
        { key: 'usuario',          label: 'Usuario',           sortable: true,  thClass: 'text-center' },
        { key: 'acciones',         label: 'acciones',          sortable: true,  thClass: 'text-center', tdClass: 'text-right' },
      ],

      listaAcciones: [],
      token_usuario: '',
      configdateTimePicker: {
        enableTime: false,
        dateFormat: 'd/m/Y',
      },
      items: [],
      descripcion: '',
      idsImagenes: [],
      estado: null,
      estados: [
        { value: '1', text: 'Activo' },
        { value: '0', text: 'Inactivo' }
      ],

      modificar:{
        estado: null,
        establecimiento: null,
        tipoImagen: null
      }
    }
  },


  async created() {
    comprobarPermisos(this.$route);
    this.setToken();
    this.establecimientosOpts = await establecimientosService.getForSelect();
    if (this.isXima) {
      this.establecimientosOpts = [
        { value: null, text: 'Todos' },
        ...this.establecimientosOpts
      ];
    }
    this.tipoImagenOpts = await fetchTipoImagenSelect();
    await this.loadCartera();
  },



  mounted() {
    actions.setearTitulo('Cartera Imagen')
  },

  methods: {

    async descargarCartIma() {
      this.descargandoExcel = true;
      const establecimientoUser = getEstablecimientoLS();
      const establecimiento = this.isXima
        ? (this.filters.establecimiento ? String(this.filters.establecimiento) : null)
        : (establecimientoUser?.id ? establecimientoUser.id.toString() : '');


      const query = `
        query GetAllImagenes(
          $search         : String, 
          $estado         : String, 
          $establecimiento: String, 
          $page           : Int, 
          $pageSize       : Int, 
          $tipoImagen     : String, 
          $excel          : String
        ) {
          allImagenes(
            search         : $search, 
            estado         : $estado,
            establecimiento: $establecimiento, 
            page           : $page, 
            pageSize       : $pageSize, 
            tipoImagen     : $tipoImagen, 
            excel:$excel
          ) {
            total
            status
            imgfile
            message
            
            pageInfo {
              currentPage
              totalPages
              hasNextPage
              hasPreviousPage
            }
          }
        }
      `;


      const variables = {
        estado          : '1',
        search          : this.filters.search,
        establecimiento : establecimiento,
        tipoImagen      : this.filters.tipoImagen,
        page            : this.table.page,
        pageSize        : this.table.pageSize,
        excel           : '1'
      }

      try{
        const response = await axios.post(rutas.axios + 'api', { query, variables });
        if(response.status !== 200) return null;
        console.log(response)

        const response2 = response.data.data.allImagenes;
        console.log('response2', response2)
        if(response2.status !== 'Success') return null;


        const archivo = response2.imgfile;
        actions.cargarArchivos(archivo, "carteraImagenes.xlsx", "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64")

      }catch(error){
        console.error('Ocurrio un error al descargar la cartera', error);
      }
      
      this.descargandoExcel = false;
    },


    async modificarItems(){

      if (!this.idsImagenes.length) {
        this.$swal.fire({
          icon: "error",
          text: "Por favor, seleccione al menos un item."
        });

        return;
      }

      if(this.modificar.estado)
        await this.modificarEstados();

      if(this.modificar.tipoImagen)
        await this.modificarTipoImagenes();

      if(this.modificar.establecimiento)
        await this.modificarEstablecimientos();

      this.$router.go(0);

    },

    async modificarEstados() {

      if (!this.modificar.estado) {
        this.$swal.fire({
          icon: "error",
          text: "Por favor, seleccione un estado."
        });

        return;
      } 
      

      const responseModificar = await carteraImagenService.cambiarEstadoMultiples(this.idsImagenes, this.modificar.estado);

      if (responseModificar) {
        await this.$swal.fire({
          title: 'Exito',
          icon: 'success',
          text: 'Estado de imagenes actualizados correctamente!'
        });

      }
      
    },


    async modificarTipoImagenes() {
      if (!this.modificar.tipoImagen) {
        this.$swal.fire({
          icon: "info",
          text: "Por favor, seleccione un tipo de imagen."
        });

        return;
      }

      const responseModificar = await carteraImagenService.modificarTipoMultiples(this.idsImagenes, this.modificar.tipoImagen);

      if (responseModificar) {
        await this.$swal.fire({
          title: 'Exito',
          icon: 'success',
          text: 'Tipo de imagen actualizado correctamente!'
        })
      }
      
    },


    async modificarEstablecimientos(){

      const responseModificar = await carteraImagenService.modificarEstablecimientoMultiples(this.idsImagenes, this.modificar.establecimiento);

      if(responseModificar){
        await this.$swal.fire({
          title: 'Exito',
          icon: 'success',
          text: 'Establecimiento actualizado correctamente!'
        });
      }
    },


    selectedImagen(id) {

      const index = this.idsImagenes.indexOf(id);
      if (index !== -1) {
        this.idsImagenes.splice(index, 1);
      } else {
        this.idsImagenes.push(id);
      }

    },

    onShowModalCreate() {
      this.navigateToQuery('createImage', '1');
    },

    onShowModalEdit(tokenImagen) {
      // this.tokenEditarImagen = tokenImagen;
      // this.showModalEdit = true;

      this.navigateToQuery('saveImage', tokenImagen);
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
    },

    cambiarPagina(newPage) {
      this.table.page = newPage;
      this.loadCartera();
    },




    async loadCartera(){

      const establecimientoUser = getEstablecimientoLS();
      const establecimiento = this.isXima
        ? (this.filters.establecimiento ? String(this.filters.establecimiento) : null)
        : (establecimientoUser?.id ? establecimientoUser.id.toString() : '');

      if (!establecimiento) {
        console.warn('No se encontró establecimiento en sesión; no se filtrarán resultados.');
      }

      const params = {
        establecimiento : establecimiento,
        search          : this.filters.search || '',
        tipoImagen      : this.filters.tipoImagen || '',
        page            : this.table.page,
        pageSize        : this.table.pageSize
      };

      const response = await carteraImagenService.getAll(params);

      if (!response || !response.imagenes) {
        this.items = [];
        this.table.totalRows = 0;
        return;
      }

      const parseFlexibleJson = (value) => {
        if (!value) return {};
        if (typeof value === 'object') return value;
        try {
          return JSON.parse(value);
        } catch (e) {
          try {
            const fixed = value
              .replace(/'/g, '"')
              .replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');
            return JSON.parse(fixed);
          } catch (error) {
            console.warn('No se pudo parsear JSON flexible', value);
            return {};
          }
        }
      };

      const estabMap = (this.establecimientosOpts || [])
        .filter(opt => opt && opt.value !== null && opt.value !== undefined)
        .reduce((acc, opt) => {
          acc[String(opt.value)] = opt.text;
          return acc;
        }, {});

      this.items = response.imagenes.map(item => {
        const nombreCompleto = `(${item.codigo}) ${item.nombre}`;
        const estadoJson = parseFlexibleJson(item.estadoJson);
        const precioJson = parseFlexibleJson(item.precioJson);
        const estIds = (item.establecimiento || '')
          .split(',')
          .map(e => e.trim())
          .filter(Boolean);
        const establecimientos = Object.entries(estabMap).map(([id, nombreEst]) => ({
          id,
          nombre: nombreEst,
          activo: estIds.includes(id)
        }));

        return {
          idImagen        : item.id,
          estado          : item.estado,
          tokenImagen     : item.token,
          establecimiento : item.establecimiento || '',
          nombre          : nombreCompleto,
          nombreCompleto,
          codigo          : item.codigo,
          precio          : item.precio,
          usuario         : item.usuarioCreador?.username || '',
          tipoImagen      : item.tipoImagen?.descripcion || '',
          establecimientos,
          estadoJson,
          precioJson
        };
      });

      this.table.totalRows = response.total;
    },


    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },

    // async fetchConsultarImagen(search = '', paginaActual = 1, establecimiento = '', pageSize, estado, tipoImagen = '', excel = '0') {

    // const query = `
    //   query GetAllImagenes(
    //     $search         : String, 
    //     $estado         : String, 
    //     $establecimiento: String, 
    //     $page           : Int, 
    //     $pageSize       : Int, 
    //     $tipoImagen     : String, 
    //     $excel          : String
    //   ) {
    //     allImagenes(
    //       search         : $search, 
    //       estado         : $estado,
    //       establecimiento: $establecimiento, 
    //       page           : $page, 
    //       pageSize       : $pageSize, 
    //       tipoImagen     : $tipoImagen, 
    //       excel:$excel
    //     ) {
    //       total
    //       status
    //       imgfile
    //       message
    //       imagenes {
    //         id
    //         token
    //         nombre
    //         establecimiento {
    //           id
    //           Descripcion
    //         }
    //         tipoImagen {
    //           id
    //           descripcion
    //         }
    //         usuarioCreador {
    //           id
    //           username
    //         }
    //         codigo
    //         estado
    //         precio
    //       }
    //       pageInfo {
    //         currentPage
    //         totalPages
    //         hasNextPage
    //         hasPreviousPage
    //       }
    //     }
    //   }
    // `;
    //   const varConsulta = {
    //     search          : search,
    //     page            : paginaActual,
    //     pageSize        : pageSize,
    //     establecimiento : establecimiento.toString(),
    //     estado          : estado,
    //     tipoImagen      : tipoImagen,
    //     excel           : excel
    //   }

    //   try {
    //     const response = await axios.post(rutas.axios + 'api', { query, variables: varConsulta });
    //     if (response.status === 200) {
    //       if (response.data.data.allImagenes.status === 'Success') {
    //         if(excel === '1'){
    //           const data = response.data.data.allImagenes.imgfile
    //           actions.cargarArchivos(data, "carteraImagenes.xlsx", "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64")
    //         }
    //         if (response.data.data.allImagenes.imagenes) {
    //           this.items = response.data.data.allImagenes.imagenes.map(item => {
    //             return {
    //               idImagen: item.id,
    //               estado: item.estado,
    //               tokenImagen: item.token,
    //               establecimiento: item.establecimiento.Descripcion,
    //               nombre: item.nombre,
    //               codigo: item.codigo,
    //               precio: item.precio,
    //               usuario: item.usuarioCreador ? item.usuarioCreador.username : '',
    //               tipoImagen: item.tipoImagen ? item.tipoImagen.descripcion : ''
    //             };
    //           });
    //           this.totalRows = response.data.data.allImagenes.total;
    //           this.currentPage = 1;
    //           this.currentPageModificado = paginaActual;
    //         } else {
    //           console.log("No se encontraron imagenes");
    //         }
    //       } else {
    //         console.log("Error en la respuesta del servidor");
    //       }
    //     }
    //   } catch (error) {
    //     console.error("Error fetching imagenes:", error);
    //   }
    // },



    buscarImagen() {
      this.loadCartera();
    },

    viewItem(tokenImagen) {
      // this.tokenSeleccionado = tokenImagen;
      // this.modalShow = true;

      this.navigateToQuery('viewImage', tokenImagen);
    },

    cargarComponente() {
      import('../Verimagen.vue').then(componente => {
        this.componenteDinamico = componente.default;
      }).catch(error => {
        console.error('Error al cargar el componente:', error);
      });
    },

    removeItemid(idImagen) {
      const mesa = this.fetchRemoveImagen(idImagen);
    },

    async fetchRemoveImagen(idImagen) {

      this.$swal({
        title: 'Estas seguro de eliminar esta Imagen?',
        text: "No seras capaz de revertir esto!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Borrar esto!',
        cancelButtonText: 'No, cancelar!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          // Call the API or method to remove the item here
          try {
            const argImg = {
              id: idImagen,
            }
            const response = await axios.post(rutas.axios + 'api', {
              query: `
                mutation EliminarImagen($id: String!) {
                  removerImagen(imagenDatos: { id: $id }) {
                    status
                    message
                  }
                }
`,
              variables: argImg
            });
            if (response.status === 200) {
              if (response.data.data.removerImagen.status === 'success') {
                if (response.status === 200) {
                  this.$swal({
                    title: 'Borrado!',
                    text: 'Tu registro ha sido eliminado',
                    icon: 'success',
                    confirmButtonColor: '#3085d6'
                  }).then((result) => {
                    // This will only run when the user presses "OK" on the "Deleted!" modal
                    if (result.isConfirmed) {
                      this.$router.go(0);
                    }
                  });
                }
                this.$router.push({ name: 'consultar_cartera_imagen' }).catch(err => {
                  if (err.name !== 'NavigationDuplicated') {
                    console.error(err);
                  }
                });
              } else {
                this.$swal({
                  title: 'Error',
                  text: response.data.data.removerImagen.message,
                  icon: 'error',
                  confirmButtonColor: '#089599',
                })
              }
            }
          } catch (err) {
            console.log(err);
            return 'Error al eliminar doctor';
          }
        } else {
          // User clicked the cancel button
          this.$swal({
            title: 'Cancelado',
            text: 'Your registro esta seguro :)',
            icon: 'error',
            confirmButtonColor: '#3085d6'
          });
        }
      });
    },

    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      this.login_user = user.username
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },

    truncateNombre(text) {
      if (!text) return '';
      return text.length > 50 ? `${text.slice(0, 50)}...` : text;
    },
  },

  computed:{
    canModificar(){
      const hasRole = comprobarRoles([ROLES.JEFE_MEDICO, ROLES.JEFE_VALIDACIONES, ROLES.AUDITOR, ROLES.JEFE_AUDITOR]);
      return hasRole
    },
    isXima() {
      return this.currentEstablecimiento?.uniCodigo === '36451';
    },



    getFiltrosAplicados() {
      // const filtrosAplicados = [];

      // if(this.filters.search)
      //   filtrosAplicados.push(`Busqueda: ${this.filters.search}`)

      // return filtrosAplicados.join('<br>');
      return ''
    }
  }

}
</script>
